<!--<style lang="less" scoped src="../css/common.less">-->
    <!--@label_width: 150px;-->
<!--</style>-->
<style lang="less" scoped>
    @import "../css/common.less";
    @label_width: 150px;
    .text{
        white-space: pre-line;
    }
</style>
<template>
    <div class="wrap">
        <h2 class="text-center">职位申请详情</h2>
        <div v-if="recruit_need.id">
            <div class="line">
                <div class="label">编号</div>
                <div class="value">{{recruit_need.uid || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">职位名称</div>
                <div class="value">{{recruit_need.recruit_job_name || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">需求团队</div>
                <div class="value">{{need_team}}</div>
            </div>
            <div class="line">
                <div class="label">工作地点</div>
                <div class="value">{{work_office}}</div>
            </div>
            <div class="line">
                <div class="label">填制人</div>
                <div class="value">
                    <CustomerPoptip class="link" :customer_id="recruit_need.fill_user_id">
                        {{recruit_need.fill_user}}
                    </CustomerPoptip>
                </div>
            </div>
            <div class="line">
                <div class="label">岗位负责人</div>
                <div class="value">
                    <CustomerPoptip class="link" :customer_id="recruit_need.apply_user_id">
                        {{recruit_need.apply_user}}
                    </CustomerPoptip>
                </div>
            </div>
            <div class="line">
                <div class="label">需求人数</div>
                <div class="value">{{recruit_need.need_count}}</div>
            </div>
            <div class="line">
                <div class="label">现有人数</div>
                <div class="value">{{recruit_need.exist_count}}</div>
            </div>
            <div class="line">
                <div class="label">薪资建议</div>
                <div class="value">{{formatNumber(recruit_need.wage_start)}} - {{formatNumber(recruit_need.wage_end)}}</div>
            </div>
            <div class="line">
                <div class="label">希望到岗时间</div>
                <div class="value">{{recruit_need.arrive_date || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">申请原因</div>
                <div class="value">{{recruit_need.recruit_reason}}</div>
            </div>
            <div class="line">
                <div class="label">详细原因</div>
                <div class="value">
                    <div class="text" v-if="recruit_need.recruit_reason_detail">{{recruit_need.recruit_reason_detail}}</div>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="line">
                <div class="label">岗位职责</div>
                <div class="value">
                    <div class="text" v-if="recruit_need.job_duty">{{recruit_need.job_duty}}</div>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="line">
                <div class="label">岗位要求</div>
                <div class="value">
                    <div class="text" v-if="recruit_need.job_require">{{recruit_need.job_require}}</div>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="line">
                <div class="label">需要 HR 协助或讨论信息</div>
                <div class="value">
                    <div class="text" v-if="recruit_need.remark">{{recruit_need.remark}}</div>
                    <div v-else>-</div>
                </div>
            </div>
            <div class="line user-flow" v-if="recruit_need.user_flow">
                <div class="label">流程状态</div>
                <div class="value">
                    <UserFlow :user_flow="recruit_need.user_flow"></UserFlow>
                </div>
            </div>
        </div>
        <div class="text-center" v-if="loading">
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import RecruitUtil from '../../../recruit/libs/util';
    import ViewerItem from '../item';
    import {mapGetters} from "vuex";
    export default {
        components: { ViewerItem },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                recruit_need: {},
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                offices_hash: 'async/offices_hash',
                teams_hash: 'async/root_teams_hash',
            }),
            need_team(){
                let team = this.teams_hash[this.recruit_need.team_id];
                return team ? team.name : '-';
            },
            work_office(){
                let office = this.offices_hash[this.recruit_need.office_id];
                return office ? office.name : '-';
            }
        },
        created(){
            this.getDetail();
        },
        mounted(){
            //
        },
        methods: {
            getDetail(){
                this.loading = true;
                RecruitUtil.getDetail(this.model_id).then((data)=>{
                    this.recruit_need = data.recruit_need;
                }).catch((e)=>{
                    this.$Modal.error({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            formatNumber(num){
                return Util.formatNumber(num);
            }
        }
    }
</script>
